export default __webpack_public_path__ + "66ee32cd87f855b5459e82db74eba6ce.svg";